/**
 * Enhanced Funnels List Page
 * Wraps the modular FunnelListPage component from the enhanced funnels module.
 * See FunnelsList.legacy.tsx for the original basic implementation.
 */
import { FunnelListPage } from '../components/list'

export default function FunnelsList() {
  return <FunnelListPage />
}
